import {
    ExpandableContentComponent as SourceExpandableContentComponent,
} from 'SourceComponent/ExpandableContent/ExpandableContent.component';
import React from 'react';
import './ExpandableContent.override.style';
import ChevronIcon from '@scandipwa/scandipwa/src/component/ChevronIcon';
import { Directions } from '@scandipwa/scandipwa/src/component/ChevronIcon/ChevronIcon.config';

export class ExpandableContentComponent extends SourceExpandableContentComponent {
    renderButtonIcon() {
        const { isContentExpanded } = this.state;
        const { isArrow, device: { isMobile }, isFooter } = this.props;

        // if (!isMobile) {
        //     return null;
        // }

        if (isFooter) {
            return this.renderTogglePlusMinus();
        }

        if (!isContentExpanded && !isArrow) {
            return null;
        }

        if (isArrow) {
            return <ChevronIcon direction={isContentExpanded ? Directions.TOP : Directions.BOTTOM} />;
        }

        if (!isContentExpanded) {
            return null;
        }

        return this.renderTogglePlusMinus();
    }
}

export default ExpandableContentComponent;
